import { calculateLineHeight } from '../utils'

export default class TextRule {
  constructor(text) {
    this.x = 0
    this.y = 0
    this.text = text
    this.parent = null
    this.width = null
    this.font = null
    this.fontSize = 0
    this.lineHeight = 0
  }

  getType() {}

  setStyle(style) {
    if (this.font === style.font) {
      return
    }
    this.width = null
    this.font = style.font
    this.fontSize = style.fontSize.value
    this.lineHeight = calculateLineHeight(style)
  }

  setParent(parent) {
    this.parent = parent
  }
}
